module.exports = __webpack_public_path__ + "static/media/star_buckss.3dd3228b.png";